import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import ROUTES from '../../../../constants/routes';
import { useEventContext } from '../../../../ek/providers/EventProvider';
import ParticipantsService from '../../../../services/ParticipantsService';
import { env } from '../../../../env';

const { REACT_APP_SEP_EVENT_TAG, REACT_APP_EXTERNAL_EVENT_TAG } = env;

const ExternalEventPage = () => {
  const navigate = useNavigate();
  const { setLaunchArgs } = useEventContext();

  useAsyncEffect(async () => {
    const urlParams = Array.from(
      new URLSearchParams(window.location.search).entries(),
    );

    const eventTagEntry = urlParams.find(
      (entry) => entry[1] === REACT_APP_EXTERNAL_EVENT_TAG,
    );

    const eventTag =
      eventTagEntry && eventTagEntry.length > 0 ? eventTagEntry[1] : '';

    console.log(`External event tag: ${eventTag}`);

    if (!eventTag) {
      return navigate(ROUTES.SELECT_EVENT);
    }

    const participantEvents =
      await ParticipantsService.getCurrentParticipantEvents();

    const externalEvent = participantEvents.events.find((pe) =>
      pe?.event?.eventTags?.includes(eventTag),
    );

    if (!externalEvent) {
      return navigate(ROUTES.SELECT_EVENT);
    }

    // Get any launch args from URL params to be sent to UE
    const formattedParams = Array.from(urlParams.entries()).map(
      ([key, value]) => `-${key}=${value}`,
    );
    setLaunchArgs(formattedParams);

    console.log(`Navigating to external event ${externalEvent.eventId}`);
    return navigate(ROUTES.EVENT_PAGE(externalEvent.eventId), {
      replace: true,
    });
  }, [setLaunchArgs]);

  return null;
};

export default ExternalEventPage;
